<template>
  <div class="container-fluid clinic-xml-recipes mt-3">
    <clinic-show-xml-recipe ref="showrecipe" @submit="getXMLRecipes(1)"></clinic-show-xml-recipe>
    <div class="row">
      <div class="col-sm-6">
        <h1 class="page-title">TALONARIOS DE RECETAS</h1>
      </div>
      <div class="col-sm-6">
        <button class="btn btn-wabident-round float-right mt-1" @click="createXMLRecipe">
          Subir nuevo talonario ...
        </button>
      </div>
    </div>

    <div class="row" v-if="has_results">
      <div class="col-md-12">
        <table class="table">
          <thead>
            <tr>
              <th>#LOTE</th>
              <th>NOMBRE ARCHIVO</th>
              <th>FECHA</th>
              <th>DOCTOR</th>
              <th>RECETAS RESTANTES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="recipe in xml_recipes.data" :key="recipe.id">
              <td>{{ recipe.lot_number }}</td>
              <td>{{ recipe.filename }}</td>
              <td>{{ formatDate(recipe.created_at) }}</td>
              <td>{{ recipe.doctor.user.name }}</td>
              <td>{{ recipe.remaining_recipes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" v-if="has_results">
      <div class="col-md-12">
        <data-pagination @gotopage="getXMLRecipes" :page="xml_recipes.current_page"
          :total="xml_recipes.last_page"></data-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      is_loading: false,
      xml_recipes: null,
    }
  },
  computed: {
    has_results() {
      return this.xml_recipes;
    },
    ...mapGetters(['clinic', 'msgwindow', 'errowindow'])
  },
  methods: {
    formatDate(date) {
      return WabiDent.fmtDate(date);
    },
    createXMLRecipe() {
      return this.$refs.showrecipe.show();
    },
    getXMLRecipes(page = 1) {
      this.is_loading = true;

      let url = `/clinic/${this.clinic.id}/xml_recipes`;
      let params = {
        page: page
      };

      axios.get(url, { params }).then((response) => {
        this.xml_recipes = response.data;
      }).catch((error) => {
        this.msgwindow.error('Error cargando talorarios de recetas');
      }).then(() => {
        this.is_loading = false;
      });
    },
  },
  mounted() {
    this.getXMLRecipes();
  }
};
</script>

<style lang="scss">
.clinic-xml-recipes {
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
    position: sticky;
    background-color: white;
    top: 0;
  }

}
</style>
